export const nations = [
  { value: 'ADMIN', name: 'Admin' },
  { value: 'ARG', name: 'Argentina' },
  { value: 'AUS', name: 'Australia' },
  { value: 'AUT', name: 'Austria' },
  { value: 'BEL', name: 'Belgium' },
  { value: 'BRA', name: 'Brazil' },
  { value: 'CAN', name: 'Canada' },
  { value: 'CZE', name: 'Czech Republic' },
  { value: 'DNK', name: 'Denmark' },
  { value: 'FIN', name: 'Finland' },
  { value: 'FRA', name: 'France' },
  { value: 'GER', name: 'Germany' },
  { value: 'GBR', name: 'Great Britain' },
  { value: 'HUN', name: 'Hungary' },
  { value: 'IRL', name: 'Ireland' },
  { value: 'ISR', name: 'Israel' },
  { value: 'ITA', name: 'Italy' },
  { value: 'JPN', name: 'Japan' },
  { value: 'LUX', name: 'Luxembourg' },
  { value: 'MRI', name: 'Mauritius' },
  { value: 'MEX', name: 'Mexico' },
  { value: 'MAR', name: 'Morocco' },
  { value: 'NLD', name: 'Netherlands' },
  { value: 'NZL', name: 'New Zealand' },
  { value: 'NOR', name: 'Norway' },
  { value: 'POL', name: 'Poland' },
  { value: 'PRT', name: 'Portugal' },
  { value: 'MKD', name: 'Republic of North Macedonia' },
  { value: 'ZAF', name: 'Republic of South Africa' },
  { value: 'RUS', name: 'Russia' },
  { value: 'SVK', name: 'Slovakia' },
  { value: 'ESP', name: 'Spain' },
  { value: 'SWE', name: 'Sweden' },
  { value: 'SUI', name: 'Switzerland' },
  { value: 'TUR', name: 'Turkey' },
  { value: 'UKR', name: 'Ukraine' },
  { value: 'USA', name: 'United States' },
  { value: 'COL', name: 'Colombia' },
  { value: 'URY', name: 'Uruguay' },
  { value: 'CYP', name: 'Republic of Cyprus'},
];

export const competitions = [
  { value: 'INDIVIDUALS', name: 'Individuals' },
  { value: 'PASDEDEUX', name: 'Pas de deux' },
  { value: 'SQUAD', name: 'Squad' },
];

export const individualCategories =
  process.env.REACT_APP_CVI === 'Pezinok' || process.env.REACT_APP_CVI === 'Brogel' || process.env.REACT_APP_CVI === 'Lier'
    ? [
        { value: 'CVI1', name: 'CVI1*' },
        { value: 'CVI2', name: 'CVI2*' },
        { value: 'CVI3', name: 'CVI3*' },
        { value: 'CVIY2', name: 'CVIY2*' },
        { value: 'CVIJ1', name: 'CVIJ1*' },
        { value: 'CVIJ2', name: 'CVIJ2*' },
        { value: 'CVICH1', name: 'CVICH1*' },
        { value: 'CVICH2', name: 'CVICH2*' },
      ]
    : [
        // Commented out for national championship in Bern as categories are a bit different. When using for regular Bern, uncomment this and remove the existing ones
        // { value: 'CVI1', name: 'CVI1*' },
        // { value: 'CVI2', name: 'CVI2*' },
        // { value: 'CVI3', name: 'CVI3*' },
        // { value: 'CVIY2', name: 'CVIY2*' },
        // { value: 'CVIJ1', name: 'CVIJ1*' },
        // { value: 'CVIJ2', name: 'CVIJ2*' },
        { value: 'CVI3', name: 'CVI3*' },
        { value: 'CVIY2', name: 'CVIY2*' },
        { value: 'CVIJ2', name: 'CVIJ2*' },
      ];

export const pasdedeuxCategories =
  process.env.REACT_APP_CVI === 'Pezinok' || process.env.REACT_APP_CVI === 'Brogel' || process.env.REACT_APP_CVI === 'Lier'
    ? [
        { value: 'CVI1', name: 'CVI1*' },
        { value: 'CVI2', name: 'CVI2*' },
        { value: 'CVI3', name: 'CVI3*' },
        { value: 'CVIJ1', name: 'CVIJ1*' },
        { value: 'CVIJ2', name: 'CVIJ2*' },
      ]
    : [
        // Commented out for national championship in Bern as categories are a bit different. When using for regular Bern, uncomment this and remove the existing ones
        // { value: 'CVI2', name: 'CVI2*' },
        // { value: 'CVI3', name: 'CVI3*' },
        // { value: 'CVIJ2', name: 'CVIJ2*' },
        { value: 'CVI3', name: 'CVI3*' },
        { value: 'CVIJ2', name: 'CVIJ2*' },
      ];

export const squadCategories =
  process.env.REACT_APP_CVI === 'Pezinok' || process.env.REACT_APP_CVI === 'Brogel' || process.env.REACT_APP_CVI === 'Lier'
    ? [
        { value: 'CVI1', name: 'CVI1*' },
        { value: 'CVI2', name: 'CVI2*' },
        { value: 'CVI3', name: 'CVI3*' },
        { value: 'CVIJ1', name: 'CVIJ1*' },
        { value: 'CVIJ2', name: 'CVIJ2*' },
      ]
    : [
        { value: 'CVI3', name: 'CVI3*' },
        { value: 'CVIJ2', name: 'CVIJ2*' },
      ];

export const joinedCategories = [
  ...individualCategories,
  ...pasdedeuxCategories,
  ...squadCategories,
];

export const genders = [{ value: 'MALE', name: 'male' }, { value: 'FEMALE', name: 'female' }];

export default {
  nations,
  competitions,
  individualCategories,
  pasdedeuxCategories,
  squadCategories,
  joinedCategories,
  genders,
};



// WEBPACK FOOTER //
// ./src/constants/values.js